import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ICategory} from '../models';
import {collection, collectionData, doc, docData, Firestore, query, where} from '@angular/fire/firestore';
import {HttpClient} from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class MediaService {

  API_URL = 'https://meinalarm.herokuapp.com/https://dataprojectserviceswebapi.azurewebsites.net/v1/VO/PVLU/';
  headers = {
    Accept: 'application/json; charset=utf-8',
    'content-type': 'application/json',
    Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6ImEzck1VZ01Gdjl0UGNsTGE2eUYzekFrZnF1RSIsImtpZCI6ImEzck1VZ01Gdjl0UGNsTGE2eUYzekFrZnF1RSJ9.eyJpc3MiOiJodHRwczovL2RhdGFwcm9qZWN0aWRlbnRpdHlzZXJ2ZXIuYXp1cmV3ZWJzaXRlcy5uZXQvY29yZSIsImF1ZCI6Imh0dHBzOi8vZGF0YXByb2plY3RpZGVudGl0eXNlcnZlci5henVyZXdlYnNpdGVzLm5ldC9jb3JlL3Jlc291cmNlcyIsImV4cCI6MTcwMDgyNDgyNCwibmJmIjoxNjY5Mjg4ODI0LCJjbGllbnRfaWQiOiJ3ZWJhcHAiLCJzY29wZSI6WyJvcGVuaWQiLCJwcm9maWxlIiwiZW1haWwiLCJkcGNsb3Vkc2VydmljZSIsIndjbWFwaXNlcnZpY2UiXSwic3ViIjoiMDkyZTZlOGItODA5MC00YzU0LWFjYmEtNmM1ZmJkYjYxMWU4IiwiYXV0aF90aW1lIjoxNjY5MDMxMjI5LCJpZHAiOiJpZHNydiIsInByZWZlcnJlZF91c2VybmFtZSI6Im5lb2JhcnNAZ21haWwuY29tIiwiYW1yIjpbInBhc3N3b3JkIl19.gRcV7zreUyQrxAH4COTztsrHU2YpCSAi8P_OQDu5rCHSF1N9UfND-yKuQll-QCn00U6SiEKx_TtSs7MKcAUNDijv7ic_h50ujLqbPux5eUXlfqJcv6gXO5gtepUYaeji4AznvLj7aZg5vCkcwsUy3NYeDtuSWrqjEqSPt37zgqYwSCFUZ5yYYqhQjbzbRq68-E_UDf35xW3Ik4C3yNNf0Q83rXn4X2kc4bfQOV-pCbxU0GWz5ci91X28yFA1XWAluzzewvYnzUklp4a1ccCknL0rhsfEWL1Jh0o3qpbaUv7MAFtFZa4_DiLpcejBy32FHj5L33i10nl99GrQlotIWg`
  }

  constructor( 
      private firestore: Firestore,
      private http: HttpClient
  ) {}

  getList(collectionName: string) {
    const chatsRef = collection(this.firestore, collectionName);
    return collectionData(chatsRef) as Observable<any>;
  }

  getItemById(collectionName: string, id: string) {
    const docRef = doc(this.firestore, `${collectionName}/${id}`);
    return docData(docRef);
  }

  getItemsByCategory(id: string) {
    const mediaRef = collection(this.firestore, 'media');
    const q = query(mediaRef, where('category', '==', id));
    return collectionData(q, { idField: 'id' }) as Observable<ICategory[]>;
  }

  getChamp() {
    return this.http.get(`${this.API_URL}`, {headers: this.headers});
  }

  getChampionship(id: string) {
    return this.http.get(`${this.API_URL}Championship/${id}`, {headers: this.headers});
  }

  getMatch(id) {
    return this.http.get(`${this.API_URL}Match/${id}`, {headers: this.headers});
  }

  getTeams() {
    return this.http.get(`${this.API_URL}Team`, {headers: this.headers});
  }

  getTeamById(id) {
    return this.http.get(`${this.API_URL}Team/${id}`, {headers: this.headers});
  }
}
